import { CommonModule } from "@angular/common";
import { Component, HostBinding, Input, OnInit } from "@angular/core";
import icons from "./icons.json";

const iconPaths = icons as unknown as Partial<Record<string, Partial<Record<string, number>>>>;

@Component({
  selector: "app-keenicon",
  templateUrl: "./keenicon.component.html",
  styleUrls: ["./keenicon.component.scss"],
  imports: [CommonModule],
})
export class KeeniconComponent implements OnInit {
  @Input() name: string;
  @Input() class: string;
  @Input() type = "duotone";

  @HostBinding("style.display")
  readonly styleDisplay = "contents";

  pathsNumber = 0;

  constructor() {}

  ngOnInit() {
    if (this.type === "duotone") {
      this.pathsNumber = iconPaths[this.type + "-paths"]?.[this.name] ?? 0;
    }
  }
}
